import React, {Component} from "react";
import {
  Image,
  ActivityIndicator,
  StyleSheet,
  View
} from "react-native";

import DefaultImage from "../Resources/img/imageload.png";

var styles = StyleSheet.create({
	backgroundImage: {
		position: "absolute",
		top: 0,
		right: 0,
		bottom: 0,
		left: 0,
	},
	activityIndicator: {
		position: "absolute",
		margin: "auto",
	},
	viewImageStyles: {
		flex: 1,
		justifyContent: "center",
		alignItems: "center"
	},
});

export default class ImageLoad extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isLoaded: false,
			isError: false
		};
		this.onLoadEnd = onLoadEnd.bind(this);
		this.onError = onError.bind(this);
	}

	render() {
		var props = this.props;
		var style = props.style;
		var source = props.source;
		var resizeMethod = props.resizeMethod;
		var resizeMode = props.resizeMode;
		var backgroundColor = props.backgroundColor;
		var loadingStyle = props.loadingStyle;
		var placeholderSource = props.placeholderSource;
		var placeholderStyle = props.placeholderStyle;

		var containerStyle = [styles.viewImageStyles];
		var backgroundImageStyle = [styles.backgroundImage, style];
		var imagePlaceholderStyle = [styles.backgroundImage, style];

		imagePlaceholderStyle.width = imagePlaceholderStyle.width + 2;
		imagePlaceholderStyle.height = imagePlaceholderStyle.height + 2;

		var activitySize = "small";
		var activityColor = "gray";

		var imagePlaceholderSource = DefaultImage;

		if(placeholderStyle)
			imagePlaceholderStyle = [placeholderStyle];

		if(backgroundColor)
			containerStyle.push({
				backgroundColor: backgroundColor
			});

		if(placeholderSource)
			imagePlaceholderSource = placeholderSource;

		if(loadingStyle) {
			if(loadingStyle.size)
				activitySize = loadingStyle.size;
			if(loadingStyle.color)
				activityColor = loadingStyle.color;
		}

		var renderActivityLoader = (!this.state.isLoaded && !this.state.isError) ? (
			<ActivityIndicator
				style={styles.activityIndicator}
				size={activitySize}
				color={activityColor} />
    ) : null;

		var renderPlaceholderImage = (!this.state.isLoaded && !this.state.isError) ? (
			<Image
				style={imagePlaceholderStyle}
				source={imagePlaceholderSource}
				resizeMethod={resizeMethod}
				resizeMode={resizeMode} />
    ) : null;

		return (
			<View style={style}>
				<Image
					onLoad={this.onLoadEnd}
					onError={this.onError}
					style={backgroundImageStyle}
					source={source}
					resizeMode={resizeMode}
					resizeMethod={resizeMethod} />
				<View style={containerStyle}>
					{renderPlaceholderImage}
					{renderActivityLoader}
				</View>
			</View>
		);
	}
}

function onLoadEnd(){
	this.setState({
		isLoaded: true
	});
}

function onError(){
	this.setState({
		isError: true
	});
}
